import { COLORS, COLORS_DIM } from "@const/healthStatus.constants";
import { ThemeName } from "@dto/usersResponse.dto";
import { parseJSON } from "@dto/util/util";

const THEME_NAME = 'theme-name';

const dmColor = '#ddd';
const dmBgColor = '#333';
const dmBgColorLight = '#444';

export abstract class ThemeUtil {

  private static themeName: ThemeName;

  static onThemeChange: (name: ThemeName) => void;

  // static readonly NAMES = Object.keys(THEMES);
  //  {
  //   dark: 'dark',
  //   light: 'light'
  // } as const;

  static getThemeName() {
    ThemeUtil.themeName ??= parseJSON<ThemeName>(localStorage.getItem(THEME_NAME)) || 'blue';
    return ThemeUtil.themeName;
  }

  static isThemeStored(): boolean {
    return localStorage.getItem(THEME_NAME) !== null;
  }

  static persistThemeMode(name: ThemeName) {
    ThemeUtil.themeName = name;
    localStorage.setItem(THEME_NAME, JSON.stringify(name));
  }

  static setTheme(name: ThemeName) {
    ThemeUtil.persistThemeMode(name);
    ThemeUtil.onThemeChange?.(name);
  }

  static isDarkMode() {
    return ThemeUtil.getThemeName() === 'dark';
  }

  static getHsColors() {
    return ThemeUtil.isDarkMode() ? COLORS_DIM : COLORS;
  }

  static getColor(lightColor?: string) {
    return ThemeUtil.isDarkMode() ? dmColor : lightColor;
  }

  static getBgColor(lightBgColor?: string) {
    return ThemeUtil.isDarkMode() ? dmBgColor : lightBgColor;
  }

  static getBgColorLight() {
    return ThemeUtil.isDarkMode() ? dmBgColorLight : undefined;
  }
}
